import React from 'react';

const Divider = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center py-12 ${className}`}>
      <div className="flex items-center space-x-4">
        <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#C9A55A]/50"></div>
        <div className="w-2 h-2 rounded-full bg-[#C9A55A]"></div>
        <div className="w-24 h-px bg-[#C9A55A]/50"></div>
        <div className="w-2 h-2 rounded-full bg-[#C9A55A]"></div>
        <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#C9A55A]/50"></div>
      </div>
    </div>
  );
};

export default Divider;